import { useState } from "react";
import Button from "@/common/ui/Button";
import { LightText2 } from "@/common/ui/Text";
import { toastMessage } from "@/utils/helper/myToast";
import { deleteSignatory } from "@/services/employee.services";

const RemoveSignatory = ({ data, onClose, afterCall }: any) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const res: any = await deleteSignatory({ empId: data?.empExtId });
      if (res?.status === 200) {
        const { message, isError } = res.data;
        onClose();
        if (afterCall) {
          setTimeout(() => {
            afterCall();
          }, 10);
        }
        return toastMessage(message, isError);
      } else {
        console.log("Error", res);
        const { message, isError } = res?.response?.data || {};
        if (message) {
          return toastMessage(message, isError);
        }
        if (res.message) {
          return toastMessage(res.message, true);
        }
      }
    } catch (error) {
      console.error("Error deleting employee", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-3 md:p-4 relative">
      <div className="px-1 pb-4">
        <LightText2 text={`Are you sure you want to remove ${data?.empId || ""} ${data?.empId ? "-" : ""} ${data?.label} as a Signatory?`} />
      </div>
      <div className="flex justify-end">
        <div className="flex justify-between gap-4">
          <Button variant="outline" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outline-danger" size="small" onClick={handleDelete} isLoading={isLoading}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RemoveSignatory;
